import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { InvoiceBuilder } from '../builders/invoice-builder';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class InvoicesApiService {
    constructor(api) {
        this.api = api;
    }
    listInvoices(isAgency, company_id) {
        if (isAgency) {
            return this.api.get('/agency/list_invoices').toPromise().then(response => {
                return response.invoices.map(data => InvoiceBuilder.buildInvoice(data));
            });
        }
        return this.api.get('/invoice/list', { company_id: company_id }).toPromise().then(response => {
            return response.invoices.map(data => InvoiceBuilder.buildInvoice(data));
        });
    }
    requestInvoice(id, format) {
        return this.api.get(`/invoice/${id}`, { format: format })
            .toPromise().then(response => response);
    }
}
InvoicesApiService.ɵfac = function InvoicesApiService_Factory(t) { return new (t || InvoicesApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
InvoicesApiService.ɵprov = i0.ɵɵdefineInjectable({ token: InvoicesApiService, factory: InvoicesApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(InvoicesApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=invoices-api.service.js.map